import { LOGO_URL } from 'config';

const LogoIcon = ({ width = 48, height = 48, style = {} }) => (
  <img src={LOGO_URL} alt="logo" width={width} height={height} style={style} />
);

export default LogoIcon;
